import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok";

const LandingHero = ({ blok }) => {
  // console.log(blok)
  const heightClassMap = {
    'small': 'h-[25vh]',
    'medium': 'h-[50vh]',
    'large': 'h-[75vh]',
    'full': 'h-[100vh]',
  }
  const heightClass = heightClassMap[blok.height] ? heightClassMap[blok.height] : 'h-[50vh]'
  const animationClass = blok.iconAnimation ? `animate-${blok.iconAnimation}` : 'animate-none'
  const isVideo = blok.bgImage?.filename?.includes('.mp4')
  
  return (
    <div className={`relative ${heightClass}`} {...storyblokEditable(blok)}>
      {!isVideo && <img loading="lazy" src={`${blok.bgImage?.filename}/m/`} alt={blok.bgImage.alt} className={`absolute w-full ${heightClass} object-cover`} /> }
      {isVideo && <video loading="lazy" src={blok.bgImage?.filename} autoPlay loop muted playsInline className={`absolute w-full ${heightClass} object-cover`} /> }
      { blok.imageMask && <div className={`absolute inset-0 bg-gradient-to-t from-gray-950 to-transparent ${heightClass}`}></div> }
      <div className={`absolute inset-0 flex flex-col items-center justify-center ${heightClass} text-white text-center`}>
        <h1 className="text-4xl font-serif">{blok.heading}</h1>
        <p className="px-2 pt-5 max-w-[600px]">{blok.subHeading}</p>
        {blok.arrowIcon && <img loading="lazy" src={blok.arrowIcon?.filename} alt={blok.arrowIcon.alt} className={`pt-12 ${animationClass}`} />}
        <div className="hidden animate-spin animate-ping animate-pulse animate-bounce" />
      </div>
    </div>
  )
};

export default LandingHero;
